/* eslint-disable eqeqeq */
/* react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import './nascarScoreboards.scss';
import { httpGet, httpGetPlain } from '../../../store/externalCalls/httpCalls';

const NascarScoreboards = (props) => {
  const { } = props;

  const [eventVFX, setEventVFX] = useState('vfx-event');
  const [eventSCOREBOARD, setEventSCOREBOARD] = useState('stats-update');

  const [cameraFilter, setCameraFilter] = useState('');
  const [contentId, setContentId] = useState('4');
  const [channel, setChannel] = useState('fox.content.' + contentId);

  const [url] = useState('interactableGraphic/fox/live/standings/');
  const [iframeUrl, setIframeUrl] = useState(process.env.REACT_APP_BACKEND_URL + url + contentId);

  const [websocketVFXCounter, setWebsocketVFXCounter] = useState(0);
  const [websocketSCOREBOARDCounter, setWebsocketSCOREBOARDCounter] = useState(0);

  const [connectionStatusVFX, setConnectionStatusVFX] = useState(false);
  const [connectionStatusSCOREBOARD, setConnectionStatusSCOREBOARD] = useState(false);

  const [historicValue] = useState(process.env.REACT_APP_BACKEND_URL + 'client/contentHistoric/');
  const [getStartIngestUrl] = useState('getStartIngestAt/');

  const [errorMsg, setErrorMsg] = useState('');
  const [okMsg, setOkMsg] = useState('');

  const [VFXList, setVFXList] = useState([]);
  const [VFXFilter, setVFXFilter] = useState([]);
  const [SCOREBOARDList, setSCOREBOARDList] = useState([]);
  const [SCOREBOARDFilter, setSCOREBOARDFilter] = useState([]);
  const [millisecondsFromStart, setMillisecondsFromStart] = useState('0');
  const [millisecondsBefore, setMillisecondsBefore] = useState('5000');
  const [millisecondsAfter, setMillisecondsAfter] = useState('5000');

  const iframeRef = useRef();

  useEffect(() => { }, []);
  const handlerChannelOnChange = (e) => setChannel(e.target.value);
  const handlerEventSCOREBOARDOnChange = (e) => setEventSCOREBOARD(e.target.value);
  const handlerHistoric = () => {
    const qs = new URLSearchParams({
      millisecondsBefore: millisecondsBefore,
      millisecondsAfter: millisecondsAfter,
    }).toString();

    const url =
      `${historicValue}` +
      `${contentId}/` +
      `${millisecondsFromStart}` +
      `?${qs}`;

    httpGetPlain(url)
      .then((res) => {
        if (res?.error) {
          alert(res.error);
          return;
        }

        (res?.data ?? []).forEach((el) => {
          Object.keys(el).forEach((k) => {
            const msg = el?.[k]?.message;
            if (!msg) return;

            sendTestWebsocketInformation({ data: [msg] }, 'VFX');
          });
        });
      })
      .catch((error) => {
        alert('Historic info not found for this content ' + JSON.stringify(error));
      });
  };
  const handlerOnConnectVFX = () => {
    setVFXList([]);
    const provider = 'soketi';

    if (channel == '' || eventVFX == '') alert('You need to define the channel and event');

    let socket_key;
    if (provider == 'soketi') socket_key = process.env.REACT_APP_WEBSOCKET_SOKETI_KEY;
    else socket_key = process.env.REACT_APP_PUSHER_KEY;

    let websocketUrl = process.env.REACT_APP_WEBSOCKET_SOKETI;
    if (provider == 'soketi') websocketUrl = process.env.REACT_APP_WEBSOCKET_SOKETI;
    else if (provider == 'laravel') websocketUrl = process.env.REACT_APP_WEBSOCKET;

    window.Pusher = Pusher;
    window.EchoVFX = new Echo({
      broadcaster: 'pusher',
      key: socket_key,
      wsHost: websocketUrl,
      disableStats: true,
      encrypted: true,
      enabledTransports: ['ws', 'wss'],
    });

    window.EchoVFX.channel(channel).listen(`.` + eventVFX, (e) => {
      handlerNewWebsocketVFXMessage(e);
    });

    setConnectionStatusVFX(true);
  };
  const handlerOnConnectSCOREBOARD = () => {
    setSCOREBOARDList([]);
    const provider = 'soketi';

    if (channel == '' || eventSCOREBOARD == '') alert('You need to define the channel and event');

    let socket_key;
    if (provider == 'soketi') socket_key = process.env.REACT_APP_WEBSOCKET_SOKETI_KEY;
    else socket_key = process.env.REACT_APP_PUSHER_KEY;

    let websocketUrl = process.env.REACT_APP_WEBSOCKET_SOKETI;
    if (provider == 'soketi') websocketUrl = process.env.REACT_APP_WEBSOCKET_SOKETI;
    else if (provider == 'laravel') websocketUrl = process.env.REACT_APP_WEBSOCKET;

    window.Pusher = Pusher;
    window.EchoSCOREBOARD = new Echo({
      broadcaster: 'pusher',
      key: socket_key,
      wsHost: websocketUrl,
      disableStats: true,
      encrypted: true,
      enabledTransports: ['ws', 'wss'],
    });

    window.EchoSCOREBOARD.channel(channel).listen(`.` + eventSCOREBOARD, (e) => {
      handlerNewWebsocketSCOREBOARDMessage(e);
    });

    setConnectionStatusSCOREBOARD(true);
  };
  const handlerOnDisconnectVFX = () => {
    if (connectionStatusVFX == true) {
      setConnectionStatusVFX(false);
      window.EchoVFX.disconnect();
      setWebsocketVFXCounter(0);
    }
  };
  const handlerOnDisconnectSCOREBOARD = () => {
    if (connectionStatusSCOREBOARD == true) {
      setConnectionStatusSCOREBOARD(false);
      window.EchoSCOREBOARD.disconnect();
      setWebsocketSCOREBOARDCounter(0);
    }
  };
  const handlerNewWebsocketVFXMessage = (msg) => {
    setWebsocketVFXCounter((prev) => prev + 1);
    setVFXList((prevItems) => [msg, ...prevItems]);
  };
  const handlerNewWebsocketSCOREBOARDMessage = (msg) => {
    setWebsocketSCOREBOARDCounter((prev) => prev + 1);
    setSCOREBOARDList((prevItems) => [msg, ...prevItems]);
    sendTestWebsocketInformation(msg, 'SCOREBOARD');
  };
  const handlerChangeUrl = (e) => setIframeUrl(e.target.value);
  const handlerChangeContentId = (e) => {
    const val = e.target.value;
    setContentId(val);
    setIframeUrl(process.env.REACT_APP_BACKEND_URL + url + val);
    setChannel('fox.content.' + val);
  };
  const handlerLoadUrl = () => {
    const startUrl = getStartIngestUrl + contentId;
    httpGet(startUrl, 'client/').then((data) => {
      if (data.startIngestAt) {
        setOkMsg(
          'LiveId=' +
          data.liveId +
          ' StartIngestAt=' +
          data.startIngestAt +
          ' (' +
          data.date +
          ') and the content has a ' +
          (data.isCCR ? 'CCR' : 'normal CR')
        );
        setErrorMsg('');
      } else {
        setErrorMsg(data.error);
        setOkMsg('');
      }
    });
    fetchIframeResponseCode(iframeUrl)
      .then((r) => {
        if (r == 'ok') {
          iframeRef.current.src = iframeUrl;
          handlerOnDisconnectVFX();
          handlerOnDisconnectSCOREBOARD();
          handlerOnConnectVFX();
          handlerOnConnectSCOREBOARD();
        } else {
          setErrorMsg(r);
        }
      })
      .catch((error) => {
        const msg = 'Unknown error ' + JSON.stringify(error);
        setErrorMsg(msg);
        setTimeout(() => setErrorMsg(''), 2000);
      });
  };
  async function fetchIframeResponseCode(url) {
    return new Promise((resolve, reject) => {
      fetch(url, { method: 'GET' })
        .then((res) => {
          if (res.status == 200) resolve('ok');
          else resolve('There is a bad statuscode ' + res.status);
        })
        .catch((error) => reject(error.message));
    });
  }
  const sendTestWebsocketInformation = (msg, mode) => {
    const iframe = iframeRef.current;
    const iframeWindow = iframe?.contentWindow;
    if (!iframeWindow) return;

    const message = { function: 'websocketValues', data: msg };
    iframeWindow.postMessage(message, process.env.REACT_APP_BACKEND_URL);
  };
  const formatTime = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(
      seconds
    ).padStart(2, '0')}`;
  };
  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };
  const rawScoreRows = cameraFilter === '' ? SCOREBOARDList : SCOREBOARDFilter;
  const isKeepAliveMessage = (element) => {
    const d0 = element?.data?.[0];
    return d0?.scoreboardData?.keepAlive === true;
  };
  const scoreRows = (rawScoreRows ?? []).filter((element) => {
    const d0 = element?.data?.[0];
    return Boolean(d0?.realTimeData || d0?.scoreboardData || isKeepAliveMessage(element));
  });
  return (
    <div className="fox-scoreboards">
      <h2 className="title">Scoreboards Monitor</h2>
      <div className="topGrid">
        <div className="card">
          <div className="cardHeader">
            <div className="block-title">Load Scoreboard</div>

            <div className={'status ' + (connectionStatusSCOREBOARD ? 'ok' : 'bad')}>
              <span className="dot" />
              SCOREBOARD
            </div>
          </div>

          <div className="cardBody">
            <form className="formCompact">
              <div className="field">
                <label htmlFor="contentId">ContentId</label>
                <input
                  className="inputSm"
                  type="text"
                  id="contentId"
                  name="contentId"
                  value={contentId}
                  onChange={handlerChangeContentId}
                />
              </div>

              <div className="field">
                <label htmlFor="scoreboardUrl">Url</label>
                <input
                  className="inputSm"
                  type="text"
                  id="scoreboardUrl"
                  name="scoreboardUrl"
                  value={iframeUrl}
                  placeholder="URL/league/contentId/cameraSelected"
                  onChange={handlerChangeUrl}
                />
              </div>

              <div className="row2">
                <div className="field">
                  <label htmlFor="channel">Channel</label>
                  <input
                    className="inputSm"
                    type="text"
                    id="channel"
                    name="channel"
                    value={channel}
                    onChange={handlerChannelOnChange}
                  />
                </div>

                <div className="field">
                  <label htmlFor="event">Event Stats</label>
                  <input
                    className="inputSm"
                    type="text"
                    id="event"
                    name="event"
                    value={eventSCOREBOARD}
                    onChange={handlerEventSCOREBOARDOnChange}
                  />
                </div>
              </div>
              <div className="row3">
                <div className="field">
                  <label>From (ms)</label>
                  <input
                    className="inputSm"
                    type="number"
                    value={millisecondsFromStart}
                    onChange={(e) => setMillisecondsFromStart(e.target.value)}
                    placeholder="0"
                  />
                </div>

                <div className="field">
                  <label>Before (ms)</label>
                  <input
                    className="inputSm"
                    type="number"
                    value={millisecondsBefore}
                    onChange={(e) => setMillisecondsBefore(e.target.value)}
                    placeholder="5000"
                  />
                </div>

                <div className="field">
                  <label>After (ms)</label>
                  <input
                    className="inputSm"
                    type="number"
                    value={millisecondsAfter}
                    onChange={(e) => setMillisecondsAfter(e.target.value)}
                    placeholder="5000"
                  />
                </div>

                <div className="field">
                  <label>&nbsp;</label>
                  <button className="btn btnGray btnWide" type="button" onClick={handlerHistoric}>
                    Load Historic
                  </button>
                </div>
              </div>
              <div className="rowButtons">
                {connectionStatusSCOREBOARD === false ? (
                  <button className="btn btnPrimary" type="button" onClick={handlerOnConnectSCOREBOARD}>
                    Connect
                  </button>
                ) : (
                  <button className="btn btnDanger" type="button" onClick={handlerOnDisconnectSCOREBOARD}>
                    Disconnect
                  </button>
                )}

                <button className="btn btnPrimary btnWide" type="button" onClick={handlerLoadUrl}>
                  LOAD SCOREBOARD
                </button>
              </div>
              {errorMsg ? <div className="alert alertError">{errorMsg}</div> : null}
              {okMsg ? <div className="alert alertOk">{okMsg}</div> : null}
            </form>
          </div>
        </div>
        <div className="card">
          <div className="cardHeader">
            <div className="block-title">Scoreboard Messages</div>
            <div className="counter">{websocketSCOREBOARDCounter}</div>
          </div>
          <div className="cardBody">
            {/* <div className="rowFilter">
              <div className="field">
                <label>Filter Camera</label>
                <input
                  className="inputSm"
                  type="text"
                  value={cameraFilter}
                  onChange={handlerChangeCameraFilter}
                  placeholder="vCR-1-1..."
                />
              </div>
            </div> */}
            <div className="table">
              <div className="tableHead">
                <div className="cell cam">CameraId</div>
                <div className="cell score">Leader</div>
                <div className="cell play">Playback</div>
                <div className="cell date">Date</div>
              </div>
              <div className="tableBody" id="scoreboardMessages">
                {scoreRows?.map((element, index) => (
                  <div key={index} className="tableRow">
                    <div className="cell cam">{element?.data[0]?.videoPublishId}</div>
                    <div className="cell score">
                      {isKeepAliveMessage(element)
                        ? 'KEEPALIVE'
                        : `${element?.data?.[0]?.scoreboardData?.leader?.name ?? ''} ${element?.data?.[0]?.scoreboardData?.leader?.carNumber ?? ''}`.trim()}
                    </div>
                    <div className="cell play">{formatTime(element?.data[0]?.realTimeData?.millisecondsFromStart)}</div>
                    <div className="cell date">{formatDate(element?.data[0]?.realTimeData?.realEpoch)}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="iframeFull">
        <div className="iframeHeader">
          <div className="block-title">Live Preview</div>
          <div className="hint">Iframe</div>
        </div>
        <iframe ref={iframeRef} id="myIframe" title="scoreboard-iframe" />
      </div>
    </div>
  );
};

export default NascarScoreboards;
